import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import RendererLayoutContainer$1 from '../../Layouts/RendererLayoutContainer.js';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var RendererLayoutContainer = function RendererLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(RendererLayoutContainer$1, _extends({
    px: 4
  }, props), children);
};
RendererLayoutContainer.propTypes = {
  children: PropTypes.node
};
RendererLayoutContainer.defaultProps = {
  children: null
};
export { RendererLayoutContainer as default };